import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, ArrowRight, Clock, User } from 'lucide-react';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import { Button } from '../components/ui/button';

const GuidesPage = () => {
  const guides = [
    {
      id: 1,
      title: 'The Ultimate Guide to Choosing CRM Software',
      excerpt: 'Everything you need to know about selecting the right CRM for your business size and industry.',
      category: 'CRM',
      readTime: '15 min read',
      image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&h=450&fit=crop'
    },
    {
      id: 2,
      title: 'Project Management Tools: A Complete Comparison',
      excerpt: 'Compare the top project management solutions and find the perfect fit for your team.',
      category: 'Productivity',
      readTime: '12 min read',
      image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&h=450&fit=crop'
    },
    {
      id: 3,
      title: 'AI Tools for Business: Getting Started Guide',
      excerpt: 'Learn how to leverage AI tools to automate tasks and boost productivity.',
      category: 'AI',
      readTime: '10 min read',
      image: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800&h=450&fit=crop'
    },
    {
      id: 4,
      title: 'Email Marketing Platform Selection Guide',
      excerpt: 'Find the best email marketing tool for your campaigns and budget.',
      category: 'Marketing',
      readTime: '8 min read',
      image: 'https://images.unsplash.com/photo-1563986768494-4dee2763ff3f?w=800&h=450&fit=crop'
    },
    {
      id: 5,
      title: 'SEO Tools Masterclass: From Beginner to Pro',
      excerpt: 'Master SEO with the right tools and strategies for organic growth.',
      category: 'SEO',
      readTime: '20 min read',
      image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&h=450&fit=crop'
    },
    {
      id: 6,
      title: 'HR Software Buying Guide for SMBs',
      excerpt: 'Streamline your HR operations with the right software solutions.',
      category: 'HR',
      readTime: '11 min read',
      image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&h=450&fit=crop'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      
      <main className="pt-24 pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Header */}
          <div className="text-center mb-16">
            <div className="w-16 h-16 bg-emerald-100 rounded-2xl flex items-center justify-center mx-auto mb-6">
              <BookOpen className="w-8 h-8 text-emerald-600" />
            </div>
            <h1 className="text-4xl font-bold text-gray-900 mb-4">Buying Guides</h1>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              In-depth guides to help you choose the right software for every business need.
            </p>
          </div>

          {/* Guides Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {guides.map((guide) => (
              <article 
                key={guide.id} 
                className="bg-white rounded-2xl overflow-hidden border border-gray-100 hover:shadow-xl hover:border-gray-200 transition-all group"
              >
                <div className="h-48 overflow-hidden">
                  <img 
                    src={guide.image} 
                    alt={guide.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-3 mb-3">
                    <span className="text-xs font-medium text-emerald-600 bg-emerald-50 px-2 py-1 rounded">
                      {guide.category}
                    </span>
                    <span className="text-xs text-gray-400 flex items-center gap-1">
                      <Clock className="w-3 h-3" /> {guide.readTime}
                    </span>
                  </div>
                  <h2 className="text-lg font-semibold text-gray-900 mb-2 group-hover:text-emerald-600 transition-colors">
                    {guide.title}
                  </h2>
                  <p className="text-sm text-gray-600 mb-4">{guide.excerpt}</p>
                  <Button variant="link" className="text-emerald-600 p-0 h-auto">
                    Read Guide <ArrowRight className="w-4 h-4 ml-1" />
                  </Button>
                </div>
              </article>
            ))}
          </div>

          {/* CTA */}
          <div className="mt-16 text-center">
            <p className="text-gray-600 mb-4">Can't find what you're looking for?</p>
            <Button asChild variant="outline">
              <Link to="/contact">Request a Guide</Link>
            </Button>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default GuidesPage;